import axios from 'axios'

export const donors = () => axios.get('v1/catalogo/orders/donors')

export const inProgressDonors = () => axios.get('v1/catalogo/orders/donors?status=in_progress')

export const addToCart = (id: string, data?: { has_treatment_clinic?: boolean }) =>
  axios.post(`v1/catalogo/orders/${id}/add`, data ?? {})

export const removeFromCart = (id: string) => axios.post(`v1/catalogo/orders/${id}/remove`)

export const reorderDonors = (donors: string[]) => axios.post('v1/catalogo/orders/reorder', { donors })

export const update = (orderInternalId: string | number, data: any) => axios.patch(`v1/catalogo/orders/${orderInternalId}`, data)

export const updateCurrentCart = (data: any) => axios.patch('v1/catalogo/orders/cart', data)

export const reservationRequest = (orderInternalId: string | number, data: any) =>
  axios.post(`v1/catalogo/orders/${orderInternalId}/reservation-request`, data)

export const fillDeclarationForm = (orderInternalId: string | number, data: any) =>
  axios.post(`v1/catalogo/orders/${orderInternalId}/declaration-form`, data)

export const fillTcleForm = (orderInternalId: string | number, data: { matching_choice: 'matching' | 'no_matching', partner_name?: string, partner_email?: string }) =>
  axios.post(`v1/catalogo/orders/${orderInternalId}/tcle-form`, data)

export const submitPaymentProofs = (orderInternalId: string | number, formData: FormData) =>
  axios.post(`v1/catalogo/orders/${orderInternalId}/payment-proofs`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

export const createPaymentLink = (orderInternalId: string | number) =>
  axios.post<{ checkout_url: string }>(`v1/catalogo/orders/${orderInternalId}/payment-link`)

// ── Pagar.me Transparent Checkout ──────────────────────────────────────────

export interface TokenizeCardPayload {
  number: string
  holder_name: string
  exp_month: number
  exp_year: number
  cvv: string
}

/**
 * Tokenize credit card data via our API (which proxies to Pagar.me).
 * Returns a card token to be used in the transparent payment request.
 */
export const tokenizeCard = (card: TokenizeCardPayload) =>
  axios.post<{ token_id: string }>('v1/catalogo/pagarme/tokenize', { card })

/**
 * Create a transparent payment (credit card) for the given order.
 */
export const createTransparentPayment = (
  orderInternalId: string | number,
  data: { card_token: string; installments: number },
) => axios.post(`v1/catalogo/orders/${orderInternalId}/transparent-payment`, data)